import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EScheduledOutcomeKind } from "@sequentech/ui-core";
import { ScheduledOutcome } from "@/components/timezones/ScheduledOutcome";
export var ETransition;
(function (ETransition) {
    ETransition["OPENED"] = "opened";
    ETransition["CLOSED"] = "closed";
})(ETransition || (ETransition = {}));
/**
 * The Publish tab's card of a scheduled opening or closing that fired at the
 * election (design §5a): authorized by the signed configuration (its signers
 * under "Authorized by", not as closing signatures); a close without
 * signatures as a neutral card naming the close requests it cancelled; or a
 * refusal with its "Why?".
 */
export var ScheduledTransitionCard = function (_a) {
    var _b;
    var transition = _a.transition, time = _a.time, post = _a.post, zone = _a.zone;
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var authorized = post.authorized_by;
    var refused = post.outcome === EScheduledOutcomeKind.REFUSED;
    var names = function (list) {
        return new Intl.ListFormat(i18n.language, { type: "conjunction" }).format(list);
    };
    var title = refused
        ? t("lifecycle.publish.".concat(transition, "Refused"), { time: time })
        : post.nothing_to_change
            ? t("lifecycle.publish.".concat(transition, "NothingToChange"), { time: time })
            : authorized
                ? t("lifecycle.publish.".concat(transition, "Authorized"), {
                    time: time,
                    code: authorized.code,
                    names: names(authorized.signers),
                })
                : post.unsigned
                    ? t("lifecycle.publish.closedUnsigned", { time: time })
                    : t("lifecycle.publish.".concat(transition, "NoSignaturesNeeded"), { time: time });
    return (_jsxs(Box, { "data-testid": "".concat(transition, "-on-schedule"), sx: {
            width: "100%",
            border: 1,
            borderColor: refused ? "warning.light" : authorized ? "success.light" : "divider",
            borderRadius: 1,
            bgcolor: authorized ? "rgba(46, 125, 50, 0.06)" : "action.hover",
            p: 2,
        }, children: [_jsx(Typography, { component: "h3", sx: { fontWeight: 600, mb: 1 }, children: title }), (authorized === null || authorized === void 0 ? void 0 : authorized.signers.length) && !refused ? (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "h4", variant: "body2", sx: { fontWeight: 600 }, children: t("lifecycle.publish.authorizedBy") }), _jsx(Box, { component: "ul", sx: { m: 0, pl: 2 }, children: authorized.signers.map(function (signer) { return (_jsx("li", { children: _jsx(Typography, { variant: "body2", children: signer }) }, signer)); }) })] })) : null, ((_b = post.cancelled) !== null && _b !== void 0 ? _b : []).map(function (request) { return (_jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mt: 1 }, children: t("lifecycle.publish.cancelledRequest", {
                    code: request.code,
                    n: request.signatures,
                    k: request.required,
                }) }, request.request_id)); }), refused && post.explanation ? (_jsx(Box, { sx: { mt: 1 }, children: _jsx(ScheduledOutcome, { explanation: post.explanation, zone: zone }) })) : null] }));
};
